<mat-accordion class="example-headers-align">
    @for (item of filteredSystems$ | async ; track item) {

    <mat-expansion-panel  [expanded]="step === 0" (opened)="setStep(0)" hideToggle>
      <mat-expansion-panel-header>
        <mat-panel-title>
          {{item.systemName}}
        </mat-panel-title>
        <mat-panel-description>
          
          <mat-icon>account_circle</mat-icon>
        </mat-panel-description>
      </mat-expansion-panel-header>
  
      <!-- <app-fillingstockcontroll  [eventData]="item"></app-fillingstockcontroll> -->
  
     
    </mat-expansion-panel>
}
  
  
  </mat-accordion>